import throttle from 'lodash.throttle';
import { useEffect, useState } from 'react';

import WindowScroll, { ScrollPosition } from '../../../app/layout/WindowScroll';
import WindowScrollObserver from '../../../app/layout/WindowScrollObserver';

const MIN_SCROLL_DELTA = 8;
const SHOW_HEADER_AT_TOP_SCROLL_Y = 80;
const HIDE_AFTER_SCROLL_DOWN_DISTANCE = 64;
const SHOW_ON_SCROLL_STOP_DELAY_MS = 300;

export default function useSiteHeaderVisibility() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let lastScrollY = WindowScroll.getPosition().scrollY;
    let downScrollStartY: number | null = null;
    let scrollStopTimeout: ReturnType<typeof setTimeout> | undefined;

    const handleScrollChange = throttle((position: ScrollPosition) => {
      const currentScrollY = Math.max(position.scrollY, 0);
      const previousScrollY = lastScrollY;
      const delta = currentScrollY - previousScrollY;

      lastScrollY = currentScrollY;

      clearTimeout(scrollStopTimeout);
      scrollStopTimeout = setTimeout(() => {
        downScrollStartY = null;
        setIsVisible(true);
      }, SHOW_ON_SCROLL_STOP_DELAY_MS);

      if (currentScrollY <= SHOW_HEADER_AT_TOP_SCROLL_Y) {
        downScrollStartY = null;
        setIsVisible(true);

        return;
      }

      if (Math.abs(delta) < MIN_SCROLL_DELTA) {
        return;
      }

      if (delta < 0) {
        downScrollStartY = null;
        setIsVisible(true);

        return;
      }

      if (downScrollStartY === null) {
        downScrollStartY = previousScrollY;
      }

      if (currentScrollY - downScrollStartY >= HIDE_AFTER_SCROLL_DOWN_DISTANCE) {
        setIsVisible(false);
      }
    }, 50);

    WindowScrollObserver.onScrollChange.subscribe(handleScrollChange);

    return () => {
      clearTimeout(scrollStopTimeout);
      handleScrollChange.cancel();
      WindowScrollObserver.onScrollChange.unsubscribe(handleScrollChange);
    };
  }, []);

  return isVisible;
}
